module.exports = __webpack_public_path__ + "static/media/folderCustom.c865cd34.png";